import { BOOLEAN_SELECT_LIST_ITEMS, Grid, GridBreak, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { StudentApplicationFilter as StudentApplicationFilterModel, StudentApplicationFilterResource, StudentGroupFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentApplicationFilter = (props: {
  filter: StudentApplicationFilterModel;
  setFilter: (value: StudentApplicationFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentApplicationFilterResource>({ permissionToApprove: false });
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentApplications.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const applicationStatusField = () => {
    const propertyName = pn<StudentApplicationFilterModel>("applicationStatuses");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.applicationStatuses?.filter((x) => props.filter.applicationStatuses?.includes(x.id))}
        options={resource.applicationStatuses}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.applicationStatuses = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const reviewerField = () => {
    const propertyName = pn<StudentApplicationFilterModel>("reviewers");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.reviewers?.filter((x) => props.filter.reviewers?.includes(x.id))}
        options={resource.reviewers}
        getOptionLabel={(option) => `${option.lastName}, ${option.firstName}`}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.reviewers = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {applicationStatusField()}
      </Grid>

      <Grid item xs={largeFieldBreakpoints}>
        {reviewerField()}
      </Grid>
    </Grid>
  );
};
